import { createZodDto } from "nestjs-zod/dto";
import { z } from "zod";

export const linkedinEndorsementModeSchema = z.enum(["endorsement", "recommendation"]);

export const linkedinEndorsementSchema = z.object({
  profileContext: z.string().min(10).max(3000),
  relationship: z.string().min(10).max(3000),
  mode: linkedinEndorsementModeSchema,
});

export class LinkedInEndorsementDto extends createZodDto(linkedinEndorsementSchema) {}

export type LinkedInEndorsementInput = z.infer<typeof linkedinEndorsementSchema>;
export type LinkedInEndorsementMode = z.infer<typeof linkedinEndorsementModeSchema>;
